import { Beneficiary, Society, StockPlan, User } from 'types';
import { getDecimalScale, getSocietyValue } from 'utils/filters';
import { isBeneficiaryPendingOfSignInvitation } from 'modules/beneficiaries/utils/isBeneficiaryPendingOfSignInvitation';

type BeneficiaryEligibilityProps = {
  actualSociety: Society;
  isAdmin: boolean;
  user: User;
  plans: StockPlan[];
  currentPlan: StockPlan;
};

type BeneficiaryEligibilityResponse = {
  beneficiariesPending: Beneficiary[];
  beneficiariesTable: Beneficiary[];
  totalShares: number;
  decimalScale: number;
};

export const beneficiaryEligibility = ({
  actualSociety,
  isAdmin,
  user,
  plans,
  currentPlan,
}: BeneficiaryEligibilityProps): BeneficiaryEligibilityResponse => {
  const planId = currentPlan?._id;
  const totalShares =
    (actualSociety.sharesCount?.actual || 0) +
    (actualSociety.sharesCount?.future || 0) +
    (actualSociety?.sharesCount?.drafts || 0);

  const societyValue = getSocietyValue(actualSociety);
  const decimalScale = societyValue ? getDecimalScale(societyValue.value) : 2;

  const filteredBeneficiaries = planId
    ? actualSociety?.beneficiaries?.filter((beneficiary) =>
        !isAdmin
          ? user['_id'] === beneficiary?.user
          : (beneficiary?.isDraft ?? false) === (currentPlan?.isDraft ?? false)
      )
    : actualSociety?.beneficiaries?.filter((beneficiary) =>
        !isAdmin ? user['_id'] === beneficiary?.user : !beneficiary?.isDraft
      );

  const filteredBeneficiariesByPlan = filteredBeneficiaries?.filter(
    (beneficiary) => beneficiary?.plan === planId
  );

  const beneficiariesTable = planId
    ? filteredBeneficiariesByPlan
    : filteredBeneficiaries;

  const beneficiariesPending = beneficiariesTable
    ?.filter((beneficiary) => isBeneficiaryPendingOfSignInvitation(beneficiary))
    .map((beneficiary) => ({
      ...beneficiary,
      planName: plans.find((plan) => plan['_id'] === beneficiary.plan)?.name,
    }));

  return {
    beneficiariesPending,
    beneficiariesTable,
    totalShares,
    decimalScale,
  };
};
